import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "firebaseDb";

const uploadChemicalSds = async (file, chemicalKey = "") => {
  const filePathKey = chemicalKey || `chemical-${Date.now()}`;
  const fileRef = ref(storage, `chemicals/sds/${filePathKey}`);
  const metadata = file?.type ? { contentType: file.type } : undefined;
  await uploadBytes(fileRef, file, metadata);
  return getDownloadURL(fileRef);
};

export default uploadChemicalSds;
